import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteMultiPurposeImageAPI,
  fetchMultiPurposeImagesAPI,
  uploadMultiPurposeImageAPI,
} from "./multiPurposeImagesAPI";
import { showModal } from "../../statusModal/statusModal";

const initialState = {
  list: [],
  fetchStatus: "idle",
  uploadStatus: "idle",
  deleteStatus: "idle",
  error: null,
};

export const fetchMultiPurposeImages = createAsyncThunk(
  "multiPurposeImages/fetchImages",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchMultiPurposeImagesAPI();
      dispatch(
        showModal({
          message: "تم جلب جميع الصور بنجاح",
          status: "success",
        })
      );
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

export const deleteMultiPurposeImage = createAsyncThunk(
  "multiPurposeImages/deleteMultiPurposeImage",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const data = await deleteMultiPurposeImageAPI(id);
      dispatch(
        showModal({
          message: "تم حذف الصوره بنجاح",
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء حذف الصوره", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete image"
      );
    }
  }
);

export const uploadMultiPurposeImage = createAsyncThunk(
  "multiPurposeImages/uploadMultiPurposeImage",
  async (imageData, { dispatch, rejectWithValue }) => {
    try {
      const data = await uploadMultiPurposeImageAPI(imageData);
      dispatch(
        showModal({
          message: "تم تحميل الصوره بنجاح",
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء تحميل الصوره", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to upload image"
      );
    }
  }
);

const multiPurposeImagesSlice = createSlice({
  name: "multiPurposeImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMultiPurposeImages.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchMultiPurposeImages.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload.data;
      })
      .addCase(fetchMultiPurposeImages.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(uploadMultiPurposeImage.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(uploadMultiPurposeImage.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(uploadMultiPurposeImage.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(deleteMultiPurposeImage.pending, (state) => {
        state.deleteStatus = "loading";
        state.error = null;
      })
      .addCase(deleteMultiPurposeImage.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.list = state.list.filter(({ _id }) => _id !== action.payload);
      })
      .addCase(deleteMultiPurposeImage.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.error = action.payload.error;
      });
  },
});

export default multiPurposeImagesSlice.reducer;
